import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class SpinnerService {
  private spinnerVisible = new BehaviorSubject<boolean>(false);
  spinnerVisible$ = this.spinnerVisible.asObservable();

  constructor() {}

  show(forDialog: boolean = false) {
    if (this.spinnerVisible.value == true) {
      return;
    }
    this.spinnerVisible.next(true);
  }

  hide(forDialog: boolean = false) {
    this.spinnerVisible.next(false);
  }

  /**
   * @deprecated This method only show the spinner and will be eventually remove.
   */
  displayMessage(mainMessage: string, HeaderMessage?: string) {
    this.show();
  }
}
